import actions from "./actions";

const initState = {

    dealers: [],
    getDealerLoading: false,
    getDealerError: null,
    getDealerMessage: null,

    dealerList: [],
    getDealerListLoading: false,
    getDealerListError: null,

    // Modify Dealer
    modifyDealerLoading: false,
    modifyDealerError: null,
    modifyDealerMessage: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_DEALER:
            return {
                ...state,
                dealers: [],
                getDealerLoading: true,
                getDealerError: null,
            };
        case actions.CREATE_DEALER_SUCCESS:
            return {
                ...state,
                dealers: action.data,
                getDealerLoading: false,
                getDealerError: null,
                getDealerMessage: action.message,
            };
        case actions.CREATE_DEALER_FAILED:
            return {
                ...state,
                getDealerLoading: false,
                getDealerError: action.error,
                getDealerMessage: null,
            }
        // Dealer List
        case actions.GET_DEALER_LIST:
            return {
                ...state,
                getDealerListLoading: true,
                getDealerListError: null,
            };
        case actions.GET_DEALER_LIST_SUCCESS:
            return {
                ...state,
                dealerList: action.payload.data,
                getDealerListLoading: false,
                getDealerListError: null,
            };
        case actions.GET_DEALER_LIST_FAILED:
            return {
                ...state,
                getDealerListLoading: false,
                getDealerListError: action.error,
            }

        // MODIFY DEALER

        case actions.MODIFY_DEALER:
            return {
                ...state,
                modifyDealerLoading: true,
                modifyDealerError: null,
                modifyDealerMessage: null,
            };

        case actions.MODIFY_DEALER_SUCCESS:
            return {
                ...state,
                modifyDealerLoading: false,
                modifyDealerError: null,
                modifyDealerMessage:
                    action.message,
            };

        case actions.MODIFY_DEALER_FAILED:
            return {
                ...state,
                modifyDealerLoading: false,
                modifyDealerError: action.error,
                modifyDealerMessage: null,
            };

       case actions.RESET_MESSAGE:
    return {
        ...state,

        getDealerMessage: null,
        getDealerError: null,
        getDealerListError: null,
        modifyDealerMessage: null,
        modifyDealerError: null,
    };
        default:
            return state;
    }
}
